module.exports = __webpack_public_path__ + "static/media/ecosentino-white.b00e5719.svg";